import type { CurrentUrlPropsV2 } from '@repo/ui/src/types/currentUrl';

export const removeQueryParam = (query: CurrentUrlPropsV2['query'], param: string) => {
  const params = new URLSearchParams(query);
  params.delete(param);
  return window.history.replaceState(null, '', `?${params.toString()}`);
};
